module.exports = __webpack_public_path__ + "static/gif-02708b70ffd66953996a4a95c47878d0.gif";